import classNames from "classnames";
import { FC, ReactElement } from "react";

import Loader from "components/Loader";
import Pagination from "components/Pagination";

type Props = {
  className?: string;
  headers: { label: string; key: string }[];
  data: Record<string, string | number | ReactElement>[];
  pagination?: {
    total: number;
    page: number;
    onPageChange: (page: number) => void;
  };
  isLoading?: boolean;
};

const Table: FC<Props> = ({ className, headers, data, pagination, isLoading }) => {
  const hasFooter = !!pagination && pagination.total > 1;

  return (
    <>
      <div className={"table__scroll"}>
        <table className={classNames("table", className, { "table--with-footer": hasFooter })}>
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header.key}>{header.label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {!isLoading &&
              data.map((item, index) => (
                <tr key={index}>
                  {headers.map((header) => (
                    <td key={header.key}>{item[header.key]}</td>
                  ))}
                </tr>
              ))}

            {isLoading && (
              <tr>
                <td colSpan={headers.length} style={{ textAlign: "center" }}>
                  <Loader isLoading inline />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {hasFooter && pagination && (
        <div className={"table__footer"}>
          <Pagination
            page={pagination.page}
            total={pagination.total}
            className="table__pagination"
            onPageChange={pagination.onPageChange}
          />
        </div>
      )}

      <div className={"table__mobile"}>
        {!isLoading &&
          data?.map((item, index) => (
            <div
              key={index}
              className={classNames("table__mobile-item", className, {
                "table__mobile-actions": headers?.[headers?.length - 1]?.key === "actions",
              })}
            >
              {headers?.map((header, headerIndex) => (
                <div key={`${header.key}-${index}-${headerIndex}`} className={"table__mobile-item-content"}>
                  {header.key !== "actions" && (
                    <span className={"table__mobile-item-content-label"}>{header.label}</span>
                  )}
                  <span className={"table__mobile-item-content-value"}>{item[header.key]}</span>
                </div>
              ))}
            </div>
          ))}

        {isLoading && (
          <div className="table__mobile-item">
            <Loader isLoading inline />
          </div>
        )}

        {!!pagination && pagination?.total > 1 && (
          <Pagination
            page={pagination.page}
            total={pagination.total}
            className="table__mobile-pagination"
            onPageChange={pagination.onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default Table;
